import { Button, CardMedia, Grid, Typography, Box } from "@mui/material";
import React, { memo, useEffect, useState } from "react";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderPage from "../../components/HeaderPage/Index";
import { isMobile } from "react-device-detect";
import {
  storeData,
  getData,
  checkEditPage,
  clearData,
  addWarterMarker,
  setHash,
} from "../../utils/GlobalHelper";
import Loading from "../../components/loading/loading";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import { createCanvas, loadImage } from "canvas";
import { styled } from "@mui/system";
import { isEmpty } from "lodash";
import DialogWait from "../../components/CustomDialog/DialogWait";
import GlobalApi from "../../utils/GlobalApi";
import Configs from "../../constants/Configs";
import clsx from "clsx";
import qs from "qs";
const header = {
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "application/json",
  },
};
const Input = styled("input")({
  display: "none",
});
const SnapIdcard = (props) => {
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const [lang, setLang] = useState(getData("lang"));
  const [translations, setTranslations] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [uploadFileRef, setUploadFileRef] = useState(
    getData("uploadImage") ? getData("uploadImage") : "",
  );
  const [imageUpload, setImageUpload] = useState("");
  const [isCheck, setIsCheck] = useState(false);
  const [isModelWait, setIsModelWait] = useState(false);
  const [isModelWaitText, setIsModelWaitText] = useState({
    title: "",
    massage: "",
    btn: "",
  });
  const mb = isMobile ? 16 : 9;
  const [editUrl, setEditUrl] = useState(false);
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const [prevFileName, setPrevFileName] = useState(null);
  const [idCardInstructions, setIdCardInstructions] = useState([]);
  const checkJumpPage = async () => {
    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1
    ) {
      return true;
    } else {
      return false;
    }
  };
  const checkEditUrl = async () => {
    checkEditPage().then((res) => {
      res ? setEditUrl(true) : setEditUrl(false);
    });
  };
  const handleNext = async () => {
    //TODO function nextPage
    if (isEmpty(head_token)) {
      checkEditPage().then(async (res) => {
        if (res) {
          storeData("checkUpload", false);
          storeData("editPage", "snapidcard");
          await props.history.push("/summary");
        }
      });
      if (prevFileName) {
        setIsLoading(true);
        await Promise.all([ocrFrontid()]);
      } else {
        props.history.push("/IdcForm");
      }
      // props.history.push("/IdcForm");
    } else {
      if (prevFileName) {
        checkEditPage().then(async (res) => {
          if (res) {
            storeData("checkUpload", false);
            storeData("editPage", "snapidcard");
            setIsLoading(true);
            await Promise.all([callPostIdCard(), ocrFrontid()]);
            await props.history.push("/summary");
          }
        });
      } else {
        props.history.push("/IdcForm");
      }
    }
  };
  const callPostIdCard = async () => {
    try {
      const body = {
        //head_token
        head_token: head_token,
        id: "0",
        image_base64: await addWarterMarker(imageUpload, false, ""),
      };
      const header = { "content-type": "application/json" };
      GlobalApi.post(
        Configs.baseAPIURL03 + "/form/document/upload/idcard/front",
        body,
        header,
      )
        .then(async (res) => {
          if (res?.data) {
            await saveImage();
            const comebackWithOtp = getData("comebackWithOtp");
            if (comebackWithOtp) {
              // to do comebackWithOtp
              checkEditPage().then((res) => {
                if (res) {
                  storeData("checkUpload", false);
                  storeData("editPage", "snapidcard");
                  props.history.push("/summary");
                } else {
                  // props.history.push("/IdcForm");
                }
              });
            } else {
              if (editUrl) {
                storeData("checkUpload", false);
                storeData("editPage", "snapidcard");
                props.history.push("/summary");
              } else {
                // props.history.push("/IdcForm");
              }
            }
          } else {
            setIsModelWaitText({
              title: "เกิดข้อผิดพลาด",
              massage: res,
              btn: translations?.[lang]?.snapidcard?.alert_upload?.btn,
            });
          }
          // setIsLoading(false);
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
  };
  const ocrFrontid = async () => {
    try {
      clearData("refId");
      // แปลง base64 เป็นไฟล์
      const file = base64ToFile(
        imageUpload,
        handleRename(checkuserinfo?.cardId),
      );
      console.log(file);

      // เตรียม FormData
      const formData = new FormData();
      formData.append("file", file);
      formData.append(
        "card_id",
        checkuserinfo.cardId ? checkuserinfo.cardId : "",
      );

      // ส่ง POST ด้วย axios (GlobalApi)
      const res = await GlobalApi.post(
        Configs.baseAPIURL01 + "/ocr/front-id",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // บาง backend อาจต้องการ
          },
        },
      );
      // ตรวจสอบผลลัพธ์
      if (res) {
        if (res?.data?.data?.refId) {
          props.history.push("/IdcForm?refId=" + res.data.data.refId);
        } else {
          props.history.push("/IdcForm");
        }
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setIsModelWaitText({
        title: "เกิดข้อผิดพลาด",
        massage: error?.message || "ไม่สามารถอัปโหลดได้",
        btn: translations?.[lang]?.snapidcard?.alert_upload?.btn,
      });
    }
  };
  const handleRename = () => {
    const originalName = "Frontid.png";
    const extension = originalName.substring(originalName.lastIndexOf("."));
    const baseName = originalName.substring(0, originalName.lastIndexOf("."));

    // วันที่และเวลาในรูปแบบ YYYYMMDD_HHmmss
    const now = new Date();
    const timestamp = now
      .toISOString()
      .replace(/[-:]/g, "")
      .replace("T", "_")
      .split(".")[0];

    // รวมชื่อไฟล์ใหม่
    const renamedFile = `${baseName}_${timestamp}_${extension}`;
    return renamedFile;
  };
  function base64ToFile(base64, filename) {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]); // decode base64
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  const uploadFile = async (e) => {
    checkEditUrl();
    const file = e?.target?.files?.[0];
    if (!file) {
      return;
    }
    if (file.name !== prevFileName) {
      console.log("ไฟล์เปลี่ยนจากเดิม:", file.name);
      setPrevFileName(file.name);
      // ทำงานกับไฟล์ใหม่ เช่น upload เป็นต้น
    } else {
      console.log("ผู้ใช้เลือกไฟล์เดิม");
    }
    if (parseFloat(file.size / 1024 / 1024) > 10) {
      setIsModelWaitText({
        title: translations?.[lang]?.snapidcard?.alert_upload?.title,
        massage: translations?.[lang]?.snapidcard?.alert_upload?.massage,
        btn: translations?.[lang]?.snapidcard?.alert_upload?.btn,
      });
    } else {
      var fileTypes = ["jpg", "jpeg", "png"];
      var extension = file.name.split(".").pop().toLowerCase(),
        isSuccess = fileTypes.indexOf(extension) > -1;
      if (isSuccess) {
        setIsLoading(true);
        setUploadFileRef("");
        const reader = new FileReader();
        reader.addEventListener(
          "load",
          function () {
            let imgSrc = reader.result;
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const imgMark = new Image();
            imgMark.src = "/images/waterMark2.png?v=4";
            loadImage(imgSrc)
              .then((image) => {
                loadImage("/images/waterMark2.png?v=4");
                const maxW = 1200;
                const maxH = 1200;
                const iw = image.width;
                const ih = image.height;
                storeData("sizeUploadImage", { width: iw, height: ih });
                const scale = Math.min(maxW / iw, maxH / ih);
                const iwScaled = iw * scale;
                const ihScaled = ih * scale;
                canvas.width = iwScaled;
                canvas.height = ihScaled;
                ctx.fillStyle = "rgb(255, 255, 255)";
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(image, 0, 0, iwScaled, ihScaled);
                const finalBase64 = canvas.toDataURL("image/jpeg", 0.5);
                storeData("uploadImage", finalBase64);
                setUploadFileRef(finalBase64);
                setIsLoading(false);
              })
              .catch((e) => {
                setIsLoading(false);
                return;
              });
          },
          false,
        );

        if (file) {
          reader.readAsDataURL(file);
        }
      } else {
        setIsModelWaitText({
          title:
            translations?.[lang]?.snapidcard?.alert_upload_file_type?.title,
          massage:
            translations?.[lang]?.snapidcard?.alert_upload_file_type?.massage,
          btn: translations?.[lang]?.snapidcard?.alert_upload_file_type?.btn,
        });
      }
    }
  };
  const saveImage = async () => {
    const uploadImage = uploadFileRef ? uploadFileRef : "";
    const uploadImage_str = uploadImage.split("data:image/jpeg;base64,");
    const hashData = setHash(uploadImage);
    const watermark_image = await addWarterMarker(uploadImage, false, "");

    try {
      var postData = {
        head_token,
        base64: uploadImage_str[1],
        type: "data:image/jpeg;base64,",
        key: "uploadImage",
        hash: hashData,
        watermark_image: watermark_image,
      };
      await GlobalApi.post(
        `${Configs.baseURL}/api/upload`,
        qs.stringify(postData),
        header,
      )
        .then((res) => {
          // setIsLoading(false);
        })
        .catch((er) => {
          setIsLoading(false);
          setIsModelWait(true);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModelWait(true);
    }
    return;
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
      key: "uploadImage",
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then((res) => {
          setIsLoading(false);
          if (res.data.api_status !== "0") {
            if (res.data.data[0].head_token === head_token) {
              let imsSrc =
                res.data.data[0].tb_image_type +
                res.data.data[0].tb_image_base64;
              setUploadFileRef(imsSrc);
            } else {
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
          setIsModelWait(true);
        });
    } catch (error) {
      setIsLoading(false);
      setIsModelWait(true);
    }
    return;
  };
  useEffect(() => {
    if (!isEmpty(uploadFileRef)) {
      setImageUpload(uploadFileRef);
      setIsCheck(true);
    }
  }, [uploadFileRef]);
  useEffect(() => {
    checkJumpPage().then((res) => {
      if (res) setJumpPage(true);
    });
  }, []);
  useEffect(() => {
    if (!isEmpty(isModelWaitText.title)) setIsModelWait(true);
  }, [isModelWaitText]);
  useEffect(() => {
    if (!isEmpty(head_token)) {
      getImage();
    }
    const translation = getData("Translations");
    if (!isEmpty(translation)) {
      setTranslations(translation);
    } else {
      props.history.push("/");
    }
    const idCardInstructions =
      translation?.["th"]?.snapidcard?.id_card_photo_instructions;
    setIdCardInstructions(idCardInstructions);
    console.log("translations", translation?.["th"]);
  }, []);
  const clickBack = () => {
    const back_from_idc = getData("back_from_idc");
    if (!back_from_idc) {
      clearData("uploadImage");
    }
    props.history.push("/pdpa");
  };

  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.snapidcard?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? clickBack() : "")}
          />
          <DialogWait
            open={isModelWait}
            isModel={setIsModelWait}
            title={isModelWaitText.title}
            massage={isModelWaitText.massage}
            btn={isModelWaitText.btn}
          />
          <Loading status={isLoading} />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.snapidcard}
                        clickBack={(e) => clickBack()}
                        editUrl={editUrl}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={mb}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          <HeaderRight
                            title={translations?.[lang]?.snapidcard?.title}
                          />
                          <ScrollBarComponent
                            content={
                              <Grid>
                                <Grid
                                  container
                                  className="font-20 font-weight-bold text-primary font-DBHeavent pt-2 pb-3"
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <CardMedia
                                      component="img"
                                      image={
                                        "../../../images/TH-ID-Card.png?v=1.0"
                                      }
                                      alt="Id Card"
                                    />
                                  </Box>
                                  {idCardInstructions && (
                                    <section className="requirements-section pt-3">
                                      <Typography
                                        gutterBottom
                                        sx={{
                                          color: "#023b66",
                                          // fontWeight: "normal !important",
                                          mb: 0.25,
                                          fontSize: 24,
                                        }}
                                      >
                                        {idCardInstructions.title}
                                      </Typography>
                                      <ul
                                        className="requirements-list"
                                        style={{
                                          marginTop: 0,
                                          paddingLeft: 20,
                                        }}
                                      >
                                        {idCardInstructions.steps?.map(
                                          (item) => (
                                            <Box
                                              component="li"
                                              key={item.param}
                                              className="requirement-item"
                                              sx={{
                                                "&::marker": {
                                                  color: "gray",
                                                },
                                              }}
                                            >
                                              <Typography
                                                variant="body2"
                                                className="requirement-label"
                                                sx={{
                                                  color: "gray",
                                                  fontWeight:
                                                    "normal !important",
                                                  mb: 0.25,
                                                  fontSize: isMobile ? 20 : 22,
                                                }}
                                              >
                                                {item.label}
                                              </Typography>
                                            </Box>
                                          ),
                                        )}
                                      </ul>
                                    </section>
                                  )}
                                  <Grid>
                                    <Typography
                                      gutterBottom
                                      // align="center"
                                      sx={{
                                        color: "#023b66",
                                        mb: 0.25,
                                        fontSize: 24,
                                      }}
                                    >
                                      {
                                        translations?.[lang]?.snapidcard
                                          ?.image_cid
                                      }{" "}
                                      {translations?.[lang]?.snapidcard?.front}
                                    </Typography>
                                  </Grid>
                                </Grid>

                                <Grid
                                  className="image-snap-card"
                                  style={{
                                    backgroundImage:
                                      "url(" + uploadFileRef + ")",
                                  }}
                                >
                                  <label htmlFor="contained-button-file">
                                    <Input
                                      accept="image/png, image/jpeg"
                                      id="contained-button-file"
                                      multiple
                                      onChange={uploadFile}
                                      onClick={(event) => {
                                        console.log(event);

                                        event.target.value = null;
                                      }}
                                      type="file"
                                    />
                                    <Button
                                      component="span"
                                      className={clsx(
                                        uploadFileRef
                                          ? "btn-snap-card-img"
                                          : "btn-snap-card",
                                      )}
                                    >
                                      <CardMedia
                                        style={{
                                          display: uploadFileRef
                                            ? "none"
                                            : "block",
                                        }}
                                        component="img"
                                        className="icon-photo"
                                        image="../../images/photo.png"
                                        alt="photo"
                                      />
                                    </Button>
                                    <Grid
                                      className="text-snap-card font-20 font-DBHeavent text-primary"
                                      style={{
                                        display: uploadFileRef ? "none" : "",
                                      }}
                                    >
                                      {translations?.[lang]?.snapidcard?.upload}
                                    </Grid>
                                  </label>
                                </Grid>
                                <Grid>
                                  <CardMedia
                                    style={{
                                      display: uploadFileRef ? "block" : "none",
                                    }}
                                    component="img"
                                    className="icon-photo-water"
                                    image="../../images/waterMark2.png?v=4"
                                    alt="photo"
                                  />
                                </Grid>
                                {/* ✅ เพิ่มช่องว่างท้ายสุดของ content */}
                                <Box
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    height: 100,
                                  }}
                                />
                              </Grid>
                            }
                          />
                          <ButtonRight
                            isDisbled
                            disbled={isCheck}
                            text={
                              editUrl
                                ? "บันทึกการแก้ไข"
                                : translations?.[lang]?.home?.next
                            }
                            onNextPage={handleNext}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
export default memo(SnapIdcard);
